import loginAuthBanner from '../../distros/arvand/prime/banners/login-auth-banner.webp'
import logoTitle from '../../distros/arvand/prime/icons/logo-title.svg'
import logoUnderTitle from '../../distros/arvand/prime/icons/logo-under-title.svg'

export const assets = Object.freeze({
  loginAuthBanner,
  logoTitle,
  logoTitleFa: logoTitle,
  logoUnderTitle,
  logoWebsite: logoTitle
})
